import React, { useContext, useEffect } from 'react';
import ViewContext from '../Context/ViewContext';
import { useDebouncedState } from '../../views/salesLedger/tradeCounter/hooks';
import { useDispatch } from 'react-redux';
import { viewActions } from '../../state/modules/view';
import { makeStyles, SearchBox } from '@fluentui/react-components';
import componentStyles from '../../styles/partials/_filterscontainer.css';
import btnStyles from '../../styles/partials/_button.css';
import WorkspaceContext from '../Context/WorkspaceContext';

const OldClearGenericFilter = ({
  genericFilter,
  updateGenericFilter,
}: {
  genericFilter?: string;
  updateGenericFilter: (newFilterValue: string) => void;
}) => {
  return genericFilter ? (
    <span
      onClick={() => {
        updateGenericFilter('');
      }}
      className={btnStyles.btnRemoveIcon}
    >
      <i className="iconSmall">clear</i>
    </span>
  ) : null;
};

const useStyles = makeStyles({
  searchBox: {
    width: '220px',
    margin: '0 0 4px 5px',
  },
});

/**
 * Provide a search box that filters the current workspace (Must be nested under a workspace to function).
 *
 * @param oldAppearance - Use the old, boxy input we've always used for workspaces. (Or set false for a fluent-ui search box).
 */
const GridToolbarWorkspaceSearch = ({ oldAppearance }: { oldAppearance?: boolean }) => {
  const { currentView, viewScreenName } = useContext(ViewContext);
  const { autofocusSearch } = useContext(WorkspaceContext);
  const dispatch = useDispatch();

  const [searchValue, , setSearchValue, setImmediateSearchValue] = useDebouncedState<string>('', 300, {
    onDebounce: (debouncedValue) => {
      dispatch(viewActions.updateGenericFilter(viewScreenName, debouncedValue));
    },
  });

  //Reset the search value if the view name changes.
  useEffect(() => {
    setImmediateSearchValue(currentView?.genericFilter ?? '');
  }, [currentView?.genericFilter, setImmediateSearchValue]);

  const styles = useStyles();

  if (oldAppearance) {
    return (
      <div className={componentStyles.searchFilterContainer}>
        <div className={componentStyles.searchFilter}>
          <input
            className={`${componentStyles.search} ignore-react-onclickoutside`}
            onChange={(event) => {
              setSearchValue(event?.target?.value ?? event);
            }}
            placeholder={'Search list'}
            value={searchValue}
            data-testid="wsSearch"
            onKeyDown={(event) => {
              event.stopPropagation();
            }}
            autoFocus={autofocusSearch ?? true}
          />
          <OldClearGenericFilter genericFilter={searchValue} updateGenericFilter={() => setSearchValue('')} />
        </div>
      </div>
    );
  }

  return (
    <SearchBox
      placeholder={'Search list'}
      value={searchValue}
      onChange={(event, data) => {
        setSearchValue(data?.value ?? '');
      }}
      appearance={'underline'}
      className={styles.searchBox}
      autoFocus={autofocusSearch ?? true}
    />
  );
};

export default GridToolbarWorkspaceSearch;
